/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PharmacyTechPatient } from '../models/PharmacyTechPatient';
import type { PharmacyTechUpload } from '../models/PharmacyTechUpload';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PharmacyTechService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Returns the list of patients for the signed-in pharmacy technician
   * @returns PharmacyTechPatient Success
   * @throws ApiError
   */
  public getPharmacyTechPatients(): CancelablePromise<
    Array<PharmacyTechPatient>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/pharmacy_tech/patient',
      errors: {
        400: `Invalid  parameters`,
        401: `UNAUTHORIZED`,
        403: `Wrong permission`,
        404: `NOT_FOUND`,
        500: `INTERNAL_SERVER_ERROR`,
        503: `SERVICE_UNAVAILABLE`,
      },
    });
  }

  /**
   * Returns HTML page to submit batch files
   * @returns any Success
   * @throws ApiError
   */
  public sendPharmacyTechHtmlPage(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/pharmacy_tech',
      errors: {
        400: `Invalid  parameters`,
        401: `UNAUTHORIZED`,
        403: `Wrong permission`,
        404: `NOT_FOUND`,
        500: `INTERNAL_SERVER_ERROR`,
        503: `SERVICE_UNAVAILABLE`,
      },
    });
  }

  /**
   * Upload batch files to Omcare Server
   * @param formData
   * @returns any Successfully Uploaded
   * @throws ApiError
   */
  public uploadBatchFile(formData?: {
    batch_file?: Blob;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/pharmacy_tech',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Invalid  parameters`,
        401: `UNAUTHORIZED`,
        403: `Wrong permission`,
        404: `NOT_FOUND`,
        500: `INTERNAL_SERVER_ERROR`,
        503: `SERVICE_UNAVAILABLE`,
      },
    });
  }

  /**
   * Returns the medication upload history for a pharmacy tech patient
   * @param id patient_customer_id
   * @returns PharmacyTechUpload Success
   * @throws ApiError
   */
  public getPharmacyTechUploads(
    id: number,
  ): CancelablePromise<Array<PharmacyTechUpload>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/pharmacy_tech/{id}/upload',
      path: {
        id: id,
      },
      errors: {
        400: `Invalid  parameters`,
        401: `UNAUTHORIZED`,
        403: `Wrong permission`,
        404: `NOT_FOUND`,
        500: `INTERNAL_SERVER_ERROR`,
        503: `SERVICE_UNAVAILABLE`,
      },
    });
  }

  /**
   * Upload a medication CSV file for a pharmacy tech patient
   * @param id patient_customer_id
   * @param formData
   * @returns any Successfully Uploaded
   * @throws ApiError
   */
  public uploadPharmacyTechFile(
    id: number,
    formData?: {
      csv_file?: Blob;
      sanitize?: boolean;
    },
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/pharmacy_tech/{id}/upload',
      path: {
        id: id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Invalid  parameters`,
        401: `UNAUTHORIZED`,
        403: `Wrong permission`,
        404: `NOT_FOUND`,
        500: `INTERNAL_SERVER_ERROR`,
        503: `SERVICE_UNAVAILABLE`,
      },
    });
  }
}
